// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"651":"web","884":"admin","933":"auth"}[chunkId] + "." + {"651":"aa56eafb","884":"54748fff","933":"aa274b7f"}[chunkId] + ".css";
};